<template>
  <div :class="$style.page">
    <Form />
  </div>
</template>

<script>
import Form from "@/components/requests/Form.vue";

export default {
  name: "RequestsPage",
  components: {
    Form,
  },
  mounted() {
    this.$store.commit("recordParams/resetRecordParams");
    this.$store.commit("orders/resetOrder");
    this.applyQueueOrderDefaults();

    this.$store.dispatch("department/fetchDepartment");
    this.$store.dispatch("department/fetchWorkDays");
  },
  methods: {
    applyQueueOrderDefaults() {
      const type = Array.isArray(this.$route?.query?.type)
        ? this.$route.query.type[0]
        : this.$route?.query?.type;
      const isQueueMode = String(type || "").toLowerCase() === "queue";

      this.$store.commit("orders/setOrderField", {
        field: "fast_source",
        value: isQueueMode ? "crm" : "online",
      });
    },
  },
};
</script>

<style lang="scss" module>
.page {
  padding: 1rem;
}
</style>
